module.exports = __webpack_public_path__ + "img/banner.4c9f636b.png";